module.exports = __webpack_public_path__ + "img/propvest-logo-light.5a8a0594.svg";